// ** React Imports
import { useEffect, useState } from 'react'

import { client } from 'src/utils/axios-client';
import { LeadScreenStore, LeadActivity, Lead, NextActivity, LeadAccountStore, ViewType, ActivityDialogStore, LeadCompanyStore, CompanyDialogStore, LeadSprintStore, SprintDialogStore } from 'src/stores/LeadStore';
import { leadEndpoints } from '../../../configs/endpoints';

// ** MUI Imports
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import Tooltip from '@mui/material/Tooltip'
import Grid from '@mui/material/Grid'
import Link from '@mui/material/Link';
import _ from 'lodash';
import LeadDataFormater from './LeadDataFormater';
import Badge, { BadgeProps } from '@mui/material/Badge';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import RadialBarChart from '../../common/RadialBarChart';
import DoActivityAccountLeadDialog from './DoActivityAccountLeadDialog';
import StandardSkeleton from '../../common/StandardSkeleton';
import RenderIf, { ClaimType, ClaimValue } from '../../common/RenderIf';



const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
    '& .MuiBadge-badge': {
        right: 33,
        top: 10,
        border: `2px solid ${theme.palette.background.paper}`,
        padding: '0 4px',
    },
}));

const DoActivitySprintInfo = () => {
    const sprintRecord = LeadSprintStore.useState(s => s.record);
    const selectedLead = LeadScreenStore.useState(s => s.selectedLead);
    const [hasLoaded, setHasLoaded] = useState(false);

    useEffect(() => {
        const fetchSprintDetails = async () => {
            setHasLoaded(false);
            const response = await client.get(leadEndpoints.getsprintleads.replace('{sprintid}', "" + selectedLead?.sprint?.id.toString()));
            LeadSprintStore.update(s => { s.record = response.data });
            setHasLoaded(true);
        }
        if (selectedLead != null && selectedLead.sprint != null) fetchSprintDetails();

        //if (!selectedLead) LeadAccountStore.update(s => { s = null });
    }, [])

    const viewSprintLeads = () => {
        SprintDialogStore.update(s => { s.sprintDialogMode = true })
    };


    if (hasLoaded) {
        return (
            <Box>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card >
                            <CardContent>
                                <Box >
                                    <Grid container spacing={2} alignContent={'flex-end'}>
                                        <Grid item xs={12} md={6} sx={{ pt: 1, display: 'flex', alignItems: 'left', flexDirection: 'column' }}>
                                            <Grid item xs={12} sx={{ alignItems: 'right' }} justifyContent={'flex-end'}>
                                                <Typography sx={{ fontSize: 20, color: 'CornflowerBlue' }} gutterBottom>
                                                    Sprint
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} md={12} sx={{ alignItems: 'right' }} justifyContent={'flex-end'}>
                                                <Grid item xs={12}>
                                                    <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'center' }}>
                                                        <Typography sx={{ fontSize: 16, }} gutterBottom>
                                                            {sprintRecord.sprintName}
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                            <RenderIf claimType={ClaimType.Leads} claimValue={ClaimValue.ViewSprint}>
                                                <Grid item xs={12} md={12} sx={{ alignItems: 'right' }} justifyContent={'flex-end'}>
                                                    <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'center' }}>
                                                        <Tooltip title='All leads related to this sprint'>
                                                            <Link
                                                                underline="hover"
                                                                component="button"
                                                                variant="caption"
                                                                onClick={viewSprintLeads}
                                                            >
                                                                Sprint Leads ({sprintRecord.leadCount})
                                                            </Link>
                                                        </Tooltip>
                                                    </Box>
                                                </Grid>
                                            </RenderIf>
                                        </Grid>
                                        <Grid item xs={12} md={6} sx={{ alignItems: 'right' }} justifyContent={'flex-end'}>
                                            <Box display="flex" justifyContent="flex-end">
                                                <RadialBarChart subHeading="Contact Rate" seriesValue={sprintRecord.connectionRate} toolTip="Contact Rate of meanigful Interactions for this sprint" />
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Box>
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Typography variant='caption'>Additional details...</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Box >
                                            <Grid container spacing={2} justifyContent={'center'}>
                                                <Grid item xs={12} md={12}>
                                                    <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'center' }}>
                                                        <LeadDataFormater labelText='Type:' valueText={sprintRecord.sprintType} textColor='' errorText='-Unknown-' chipHeight={20} chipFontSize='0.75rem' chipfontWeight={500} isChip={false} />
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={12} md={12}>
                                                    <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'center' }}>
                                                        <LeadDataFormater labelText='Status:' valueText={sprintRecord.sprintStatus} textColor='' errorText='-Unknown-' chipHeight={20} chipFontSize='0.75rem' chipfontWeight={500} isChip={false} />
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={12} md={12}>
                                                    <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'center' }}>
                                                        <LeadDataFormater labelText='Customer:' valueText={sprintRecord.customerName} textColor='' errorText='-Unknown-' chipHeight={20} chipFontSize='0.75rem' chipfontWeight={500} isChip={false} />
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={12} md={12}>
                                                    <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'center' }}>
                                                        <LeadDataFormater labelText='Start Date:' valueText={sprintRecord.startDate} textColor='' errorText='-Unknown-' chipHeight={20} chipFontSize='0.75rem' chipfontWeight={500} isChip={false} />
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={12} md={12}>
                                                    <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'center' }}>
                                                        <LeadDataFormater labelText='End Date:' valueText={sprintRecord.endDate} textColor='' errorText='-Unknown-' chipHeight={20} chipFontSize='0.75rem' chipfontWeight={500} isChip={false} />
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={12} md={12}>
                                                    <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'center' }}>
                                                        <LeadDataFormater labelText='Playbook' valueText={sprintRecord.playbookName} textColor='' errorText='-Unknown-' chipHeight={20} chipFontSize='0.75rem' chipfontWeight={500} isChip={false} />
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    </AccordionDetails>
                                </Accordion>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Box>
        )
    }
    else {
        return <StandardSkeleton />
    }

}

export { DoActivitySprintInfo }

export default DoActivitySprintInfo;